import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Component, inject, input } from '@angular/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { HelpLinkDirective } from '../../../components/help-link/help-link.directive';
import { IconButtonBackground, IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { DataAnalyticsService } from '../../../services/data-analytics/data-analytics.service';
import { DataAnalyticsTaggingConstants } from '../../data-analytics-tagging/data-analytics-tagging.constants';

@Component({
  selector: 'td-wb-toolbar-item-help',
  templateUrl: 'toolbar-item-help.component.html',
  styleUrls: ['toolbar-item-help.component.scss'],
  imports: [
    IconComponent,
    HelpLinkDirective,
    IconButtonComponent,
    AsyncPipe,
    TranslatePipe,
    TranslatePipe
  ]
})
export class ToolbarItemHelpComponent {
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly dataAnalyticsService = inject(DataAnalyticsService);

  readonly articleId = input<string>(undefined);
  readonly iconType = input<'primary' | 'primary2' | 'inverse' | 'secondary'>(undefined);
  readonly autoSizeOverride = input<boolean>(true);
  readonly tdWbIconButtonBackground = input<IconButtonBackground>('grey');

  breakpointChanges: Observable<BreakpointState>;

  constructor() {
    if (this.autoSizeOverride()) {
      this.breakpointChanges = this.mediaQueryService.observe(Breakpoint.LT_MD);
    }
  }

  onClick(): void{
    this.dataAnalyticsService.emitEvent(DataAnalyticsTaggingConstants.getLinkClickEventData('tdw:et:help'));
  }
}
